import apiClient from './api'

// SegmentDefinition interface pentru enriched data
export interface SegmentDefinition {
  id: string
  code: string
  display_name: string
  display_name_ro?: string
  region_id?: string
  modality: string
  laterality?: string
}

export interface PendingMapping {
  id: string
  tenant_id: string
  study_id?: string
  source_type: 'dicom_tags' | 'easymedical' | 'manual'
  source_text: string
  context_data?: Record<string, any>
  suggested_code?: string
  confidence: number
  status: 'pending' | 'approved' | 'rejected'
  approved_code?: string
  approved_confidence?: number
  reviewed_by?: string
  reviewed_at?: string
  review_notes?: string
  created_at: string
  updated_at: string
  
  // Enriched from backend
  suggested_segment?: SegmentDefinition
}

export interface PendingMappingsListResponse {
  items: PendingMapping[]
  total: number
  page: number
  limit: number
  has_next: boolean
  has_prev: boolean
}

export interface ApproveMappingRequest {
  approved_code: string
  confidence: number
  review_notes?: string
}

export interface RejectMappingRequest {
  review_notes?: string
}

export interface UpdateMappingRequest {
  suggested_code?: string
  review_notes?: string
}

export interface MappingActionResponse {
  success: boolean
  message: string
  mapping_id: string
  action: 'approved' | 'rejected' | 'updated'
}

export interface ReviewMappingsStatsResponse {
  total: number
  pending: number
  approved: number
  rejected: number
  by_source_type: {
    dicom_tags: number
    easymedical: number
    manual: number
  }
}

export interface PendingMappingsFilters {
  source_type?: 'dicom_tags' | 'easymedical' | 'manual'
  study_id?: string
  suggested_code?: string
  status?: 'pending' | 'approved' | 'rejected'
  page?: number
  limit?: number
}

export const reviewMappingsApi = {
  /**
   * Obține lista de mapări în așteptare
   */
  async getPendingMappings(filters: PendingMappingsFilters = {}): Promise<PendingMappingsListResponse> {
    const params: Record<string, any> = {
      page: filters.page || 1,
      limit: filters.limit || 50
    }
    
    if (filters.source_type) params.source_type = filters.source_type
    if (filters.study_id) params.study_id = filters.study_id
    if (filters.suggested_code) params.suggested_code = filters.suggested_code
    if (filters.status !== undefined) params.status = filters.status
    
    const response = await apiClient.get('/review-mappings/pending', { params })
    return response.data
  },

  /**
   * Aprobă o mapare
   */
  async approveMapping(
    mappingId: string,
    request: ApproveMappingRequest
  ): Promise<MappingActionResponse> {
    const response = await apiClient.post(`/review-mappings/${mappingId}/approve`, request)
    return response.data
  },

  /**
   * Respinge o mapare
   */
  async rejectMapping(
    mappingId: string,
    request: RejectMappingRequest
  ): Promise<MappingActionResponse> {
    const response = await apiClient.post(`/review-mappings/${mappingId}/reject`, request)
    return response.data
  },

  /**
   * Actualizează o mapare pending
   */
  async updateMapping(
    mappingId: string,
    request: UpdateMappingRequest
  ): Promise<MappingActionResponse> {
    const response = await apiClient.put(`/review-mappings/${mappingId}`, request)
    return response.data
  },

  /**
   * Obține statistici despre mapări
   */
  async getStats(): Promise<ReviewMappingsStatsResponse> {
    const response = await apiClient.get('/review-mappings/stats')
    return response.data
  }
}

